export default __webpack_public_path__ + "static/media/POLLUTION-1.1fac007f.jpg";